import { render } from "./message-queue-confirmation.vue?vue&type=template&id=0180b762&scoped=true&ts=true"
import script from "./message-queue-confirmation.vue?vue&type=script&lang=ts"
export * from "./message-queue-confirmation.vue?vue&type=script&lang=ts"

import "./message-queue-confirmation.vue?vue&type=style&index=0&id=0180b762&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0180b762"]])

export default __exports__